import cx from "classnames";
import { BigImageSlider } from "components/ImageSlider/BigImageSlider";
import { ImageSlider } from "components/ImageSlider/ImageSlider";
import { FC, useEffect, useMemo, useRef } from "react";
import Slider from "react-slick";
import {
  ProductBySlugQuery,
  ResponsiveImage,
} from "services/datocms/generated";
import st from "./MachineImages.module.scss";

type MachineImagesProps = {
  datoProduct: ProductBySlugQuery["product"];
  selectedImage: number;
  setSelectedImage: (index: number) => void;
  title: string;
  bundleImage?: ResponsiveImage | null;
  secondaryContainerClassName?: string;
};

export const MachineImages: FC<MachineImagesProps> = ({
  datoProduct,
  selectedImage,
  setSelectedImage,
  title,
  bundleImage,
  secondaryContainerClassName,
}) => {
  const smallSliderRef = useRef<Slider>(null);
  const bigSliderRef = useRef<Slider>(null);

  useEffect(() => {
    smallSliderRef.current?.slickGoTo(selectedImage);
    bigSliderRef.current?.slickGoTo(selectedImage);
  }, [selectedImage]);

  const productImages = useMemo(() => {
    const productImages =
      datoProduct?.productImages.map((image) => {
        return image.responsiveImage;
      }) ?? [];

    if (bundleImage) {
      productImages.unshift(bundleImage);
    }

    return productImages;
  }, [datoProduct?.productImages, bundleImage]);

  return (
    <div className={st.machineImagesContainer}>
      <div
        className={cx(
          "w-full flex justify-center bg-white rounded-[30px]",
          secondaryContainerClassName,
        )}
      >
        <BigImageSlider
          datoProduct={datoProduct}
          items={productImages as ResponsiveImage[]}
          ref={bigSliderRef}
          setSelectedImage={setSelectedImage}
        />
      </div>
      {productImages && productImages.length > 1 && (
        <div className="w-full flex items-center gap-2 mt-4 p-1">
          {/* must set a max width to avoid pushing the layout container.
          slick carousel has a really hard time with ancestors that are 'flex' */}
          <div className="m-auto p-2 max-w-full md:max-w-[360px]">
            <ImageSlider
              ref={smallSliderRef}
              title={title}
              items={productImages as ResponsiveImage[]}
              setSelectedImage={setSelectedImage}
              selectedImage={selectedImage}
              threeDImage={
                datoProduct?.product3dPoster?.responsiveImage || undefined
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};
